import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconSocialXSvg } from "./IconSocialXSvg.mjs";
const IconSocialX = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconSocialXSvg, ...svgProps }) });
export {
  IconSocialX
};
